"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetYourFreeQuoteIn4SimpleSteps() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return null;
}